Ext.define('SA.EditPanelHeaderSelectionButtons', {
    alias: 'widget.edit-panel-header-selection-buttons',
    extend: 'SA.view.SimpleContainer',

    cls: 'sa-edit-panel-header-selection-buttons',

    items: [
        {
            xtype: 'component',
            itemId: 'selectAllBtn',
            cls: 'sa-edit-panel-header-selection-buttons-button',
            html: 'Select all'
        }, {
            xtype: 'component',
            cls: 'sa-edit-panel-header-selection-buttons-separator'
        }, {
            xtype: 'component',
            itemId: 'clearBtn',
            cls: 'sa-edit-panel-header-selection-buttons-button',
            html: 'Clear'
        }
    ],

    initEvents() {
        this.callParent();

        this.down('#selectAllBtn').el.on('click', () => this.fireEvent('selectAll:click'));
        this.down('#clearBtn').el.on('click', () => this.fireEvent('clear:click'));
    },

    onClearClick(callback, scope) {
        this.on('clear:click', callback, scope);
    },

    onSelectAllClick(callback, scope) {
        this.on('selectAll:click', callback, scope);
    },

    setEnabled(enabled) {
        this.ifCls(enabled, 'sa-edit-panel-header-selection-buttons-enabled');
    }
});